import {Injectable} from '@angular/core';
import {
	MissingTranslationHandler  as NgXMissingTranslationHandler,
	MissingTranslationHandlerParams
} from '@ngx-translate/core';
import {LogManager, LogCat} from '../../log';


/**
	* **********************************************************
	* Service that implements the interface
	* MissingTranslationHandler for ng2-translate.
	*
	* Written by: Dana Moshe
	* **********************************************************
	*/
@Injectable()
export class MissingTranslationHandler implements NgXMissingTranslationHandler {
	handle(params: MissingTranslationHandlerParams) {
		LogManager.debug(LogCat.Translate.MissingTranslation, "key:" + params.key);
		return '[' + params.key + ']';
	}
}

